import styled from 'styled-components';
import { respondTo } from 'components/styles/_respondTo';
import { colors } from 'components/styles/_variables';

export const Wrapper = styled.div`
  ${respondTo.desktop`
    width: 270px;
    left: 0;
      justify-content: space-between;
  `}
  position: fixed;
  width: 100vw;
  top: 59px;
  height: calc(100vh - 59px);
  z-index: 998;
  right: ${({ open }) => (open ? 0 : '-100vw')};
  background-color: ${colors.theme.primary};
  transition: 0.3s ease all;
  overflow-y: auto;
  box-shadow: 0 16px 16px 0 rgba(0, 0, 0, 0.34);
  display: flex;
  flex-direction: column;
  //justify-content: space-between;
`;

export const List = styled.ul`
  margin-top: ${({ footer }) => (footer ? 0 : 10)}px;
  ${respondTo.desktop`
    margin-top: ${({ desktop_mb = 0 }) => desktop_mb}px;
     
    &:first-child {
      @media (min-height: 800px) {
        padding-top: 40px;
      }
    }
  `}
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 20px;
`;

export const ModalDescription = styled.p`
  width: fit-content;
  text-align: left;
  margin-left: 15px;
`;

export const ModalList = styled.ul`
  width: fit-content;
  text-align: left;
  margin-left: 30px;
`;
